import './index.css';
import SmoothScroll from './components/SmoothScroll';
import Header from './components/Header';
import Hero from './components/Hero';
import Problem from './components/Problem';
import Platform from './components/Platform';
import HowItWorks from './components/HowItWorks';
import Capabilities from './components/Capabilities';
import ImageSection from './components/ImageSection';
import WhoFor from './components/WhoFor';
import WhyTruVue from './components/WhyTruVue';
import Security from './components/Security';
import Industries from './components/Industries';
import FAQ from './components/FAQ';
import CTABand from './components/CTABand';
import Footer from './components/Footer';

import Gallery from './components/Gallery';

export default function App() {
  return (
    <>
      <SmoothScroll />
      <Header />
      <main>
        <Hero />
        {/* <ImageSection /> */}
        <Problem />
        <Platform />
        <HowItWorks />
        <Capabilities />
        <WhoFor />
        <Gallery />
        <WhyTruVue />
        <Security />
        <Industries />
        <FAQ />
        {/* <CTABand /> */}
      </main>
      <Footer />
    </>
  );
}
